import { useMemo } from 'react';
import { createIntl } from 'react-intl';

import { getFormattingLocale } from '../../utils';

/** Intl instance for the user's formatting locale, which can differ from the UI language that `useIntl()` uses. */
export function useFormattingIntl() {
  const locale = getFormattingLocale();

  return useMemo(() => createIntl({ locale }), [locale]);
}
